import { render, staticRenderFns } from "./PaywaySingle.vue?vue&type=template&id=124d188e"
import script from "./PaywaySingle.vue?vue&type=script&lang=js"
export * from "./PaywaySingle.vue?vue&type=script&lang=js"
import style0 from "./PaywaySingle.vue?vue&type=style&index=0&id=124d188e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports